import { defineStore } from 'pinia';

import type {
	FilterStoreState,
	SetDesiredSearchFieldStateVisiblePayload,
	SetHiddenSearchTermPayload,
	SetSearchTermPayload,
} from './interfaces';

const createDefaultState = (): FilterStoreState => ({
	desiredSearchFieldStateIsVisible: new Map<string, boolean>(),
	hiddenSearchTermForModule: new Map<string, string>(),
	searchTermForModule: new Map<string, string>(),
});

export const useFilterStore = defineStore('filter', {
	actions: {
		// Task 3.1 (List-Isolation-Teardown): löscht Searchterms für eine dispose-te Listen-Instanz.
		// Gekeyt via handle.genericListIdentifier (siehe FilterComponentActions.ts/FilterComponentComputedProperties.ts
		// — Sidebar-Filter-Apply-Pfad für Listen-Instanz-Tabs), sonst wächst diese Map monoton pro geöffnetem
		// Tab (Leak). NICHT enthalten: desiredSearchFieldStateIsVisible — wird ausschließlich mit
		// moduleRouteName/route.name aufgerufen (kein handle-basierter Call-Site gefunden), anderer, bounded
		// Keyspace.
		clearForIdentifier(genericListIdentifier: string): void {
			this.hiddenSearchTermForModule.delete(genericListIdentifier);
			this.searchTermForModule.delete(genericListIdentifier);
		},
		desiredSearchFieldStateVisible(module: string): boolean {
			return this.desiredSearchFieldStateIsVisible.has(module)
				? (this.desiredSearchFieldStateIsVisible.get(module) as boolean)
				: false;
		},
		hiddenSearchTerm(module: string): string {
			return this.hiddenSearchTermForModule.has(module)
				? (this.hiddenSearchTermForModule.get(module) as string)
				: '';
		},
		searchTerm(module: string): string {
			return this.searchTermForModule.has(module) ? (this.searchTermForModule.get(module) as string) : '';
		},
		setDesiredSearchFieldStateVisible(payload: SetDesiredSearchFieldStateVisiblePayload): void {
			this.desiredSearchFieldStateIsVisible.set(payload.module, payload.desiredSearchFieldStateVisible);
		},
		setHiddenSearchTerm(payload: SetHiddenSearchTermPayload): void {
			this.hiddenSearchTermForModule.set(payload.module, payload.hiddenSearchTerm);
		},
		setSearchTerm(payload: SetSearchTermPayload): void {
			this.searchTermForModule.set(payload.module, payload.searchTerm);
		},
	},
	state: createDefaultState,
});
export * from './interfaces';
export * from './types';
